import React from 'react';
import styled from 'styled-components';
import LoadingSpinner from 'ui/LoadingSpinner/LoadingSpinner';

type WithLoadingProps = {
  isLoading: boolean;
  children: React.ReactNode;
};

const LoadingOverlay = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const withLoading = (Component: React.FunctionComponent<any>) => {
  return ({ isLoading, children, ...props }: WithLoadingProps) => {
    if (!isLoading) return <Component {...props}>{children}</Component>;
    return (
      <LoadingOverlay>
        <LoadingSpinner />
      </LoadingOverlay>
    );
  };
};

export default withLoading;
